import { render, staticRenderFns } from "./logo-img.vue?vue&type=template&id=2cc39f70&scoped=true&"
import script from "./logo-img.vue?vue&type=script&lang=js&"
export * from "./logo-img.vue?vue&type=script&lang=js&"
import style0 from "./logo-img.vue?vue&type=style&index=0&id=2cc39f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc39f70",
  null
  
)

export default component.exports